import { useEffect, useState } from "react";
import {  emptyRow, RowObject, Spell } from "../../Types/TableTypes";
import { useTranslation } from "react-i18next";
import MonsterSearchModal from "./MonsterSearchModal";
import React from "react";

interface HeaderButtonsComponentProps{
    // round: number,
    currentTurn: number,
    editMode: boolean,
    creatures: RowObject[],
    setCreatures: (creatures: RowObject[])=>void,
    setCurrentTurn: (currentTurn: number)=>void,
    setEditMode: (editMode: boolean)=>void
}

const HeaderButtonsComponent = (props: HeaderButtonsComponentProps)=>{
    const [isModalOpen, setIsModalOpen] = useState (false);
    const [round, setRound] = useState(1);
    const [idSequence, setIdSequence] = useState(props.creatures.length);
    const { t } = useTranslation();
    
    useEffect(() => {
        // console.log("useeffect headerbuttons");
        let maxId = 0;
        props.creatures.forEach(element => {
            if (element.id > maxId) {
                maxId = element.id;
            }
        });
        setIdSequence (maxId + 1);
    },[props.creatures]);

    function sortRows():void{
        props.creatures.sort(function(a, b) {
            return b.encounterStats.initiative - a.encounterStats.initiative;
        });
        props.setCreatures([...props.creatures]);
    }

    function closeModal(){
        setIsModalOpen(false);
    }

    function exportEncounter(){
        const blob = new Blob([JSON.stringify(props.creatures)], { type: "text/plain" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.download = "encounter.json";
        link.href = url;
        link.click();
    }
    
    function nextRound(){
        setRound(round+1);
        props.setCurrentTurn(0);
        props.creatures.forEach((creature, index)=>{
            if (index === 0)
                props.creatures[index].encounterStats.expanded = true;
            else{
                props.creatures[index].encounterStats.expanded = false
            }
            props.creatures[index].encounterStats.reaction=false;
        });
    }
    
    function nextTurn(){
        let currentTurn = props.currentTurn;
                if (props.currentTurn === props.creatures.length -1){
            setRound(round+1);
            props.setCurrentTurn(0);
            currentTurn = 0;
            props.creatures.forEach((creature, index)=>{
                if (index === currentTurn)
                    props.creatures[index].encounterStats.expanded = true;
                else{
                    props.creatures[index].encounterStats.expanded = false
                }
                props.creatures[index].encounterStats.reaction=false;
            });
        }
        else{
            props.setCurrentTurn(props.currentTurn+1);
            currentTurn ++;
            props.creatures.forEach((creature, index)=>{
                if (index === currentTurn)
                    props.creatures[index].encounterStats.expanded = true;
                else{
                    props.creatures[index].encounterStats.expanded = false
                }
            });
        }
        props.setCreatures([...props.creatures]);
    }

    function previousTurn(){
        if (props.currentTurn === 0 && round > 1){
            setRound(round-1);
            props.setCurrentTurn(props.creatures.length -1);
            // creatures.map((creature, index)=>creatures[index].reaction=false);
            // setCreatures([...creatures]);
        }
        else{
            if (props.currentTurn !== 0 && round > 0)
                props.setCurrentTurn(props.currentTurn-1);
        }
    }

    // const onClickLanguageChange = (e: any) => {
    //         const language = e.target.value;
    //         i18n.changeLanguage(language); //change the language
    //     }

    return(
            <div className="d-flex black justify-content-between px-4 py-2 header navbar text-white bg-dark">
                <span className="buttons">
                    <button className="btn btn-success" onClick={e=>{emptyRow.id = idSequence; props.setCreatures([...props.creatures,structuredClone(emptyRow)]); setIdSequence(idSequence+1)}}>{t("button-addrow")}</button>
                    <button className="btn btn-primary" onClick={e=>setIsModalOpen(true)}>{t("button-searchmonster")}</button>
                    {isModalOpen && 
                        <MonsterSearchModal
                            nextMonsterIndex={props.creatures.length}
                            addMonster={(monster: RowObject)=>{
                                monster.id = idSequence;
                                setIdSequence(idSequence+1);
                                props.creatures.push(monster);
                                props.setCreatures([...props.creatures]);
                            }}
                            addSpell={(monsterIndex: number, spellGroupIndex: number, spell: Spell) =>{
                                props.creatures[monsterIndex].creatureStats.spellcasting.spellGroups[spellGroupIndex].list.push(spell);
                                props.setCreatures([...props.creatures]);
                            }}
                            closeModal={closeModal}
                        />
                    }
                    <button className="btn btn-warning" onClick={e=>sortRows()}>{t("button-sort")}</button>
                </span>
                <span className="buttons">
                
                    <button className="btn btn-secondary" onClick={e=>document.getElementById("file-input")?.click()}>{t("button-import")}</button>
                    <input type="file"
                        style={{display: "none"}}
                        name="myFile"
                        id="file-input"
                        onChange={async e=>{
                            if (e.target.files != null){
                                let file = e.target.files[0];
                                // console.log(file);
                                
                                if (file) {
                                    let fileJson =  JSON.parse(await file.text());
                                    props.setCreatures([...fileJson]);
                                }
                            }
                        }} />
                    <button className="btn btn-secondary" onClick={e=>exportEncounter()}>{t("button-export")}</button>
                    {/* <span className="btn-group" role="group" aria-label="Basic radio toggle button group">
                        <input type="radio" className="btn-check" name="btnradio" id="btnradio1" value="en" autoComplete="off" checked={i18n.language === "en"} onChange={onClickLanguageChange}/>
                        <label className="btn btn-outline-primary" htmlFor="btnradio1">English</label>
                        <input type="radio" className="btn-check" name="btnradio" id="btnradio3" value="it" autoComplete="off" checked={i18n.language === "it"} onChange={onClickLanguageChange}/>
                        <label className="btn btn-outline-primary" htmlFor="btnradio3">Italiano</label>
                    </span> */}
                    {/* <span className="btn-group" role="group" aria-label="Basic radio toggle button group">
                        <input type="radio" className="btn-check" name="editradio" id="editradio" autoComplete="off" checked={props.editMode} onChange={e => props.setEditMode(true)}/>
                        <label className="btn btn-outline-primary" htmlFor="editradio">{t("button-editmode")}</label>
                        <input type="radio" className="btn-check" name="viewradio" id="viewradio" autoComplete="off" checked={!props.editMode} onChange={e => props.setEditMode(false)}/>
                        <label className="btn btn-outline-primary" htmlFor="viewradio">{t("button-viewmode")}</label>
                    </span> */}

                </span>
                <span className="buttons">
                    <span className="fs-4">Round {round}</span>
                    <button className="btn btn-success" onClick={e=>nextRound()}>{t("button-nextround")}</button>
                    <button className="btn btn-secondary" onClick={e=>previousTurn()}>{t("button-previousturn")}</button>
                    <button className="btn btn-primary" onClick={e=>nextTurn()}>{t("button-nextturn")}</button>
                </span>
            </div>
    )
}
export default React.memo(HeaderButtonsComponent);